import { render, staticRenderFns } from "./ConversationsSearchListVirtual.vue?vue&type=template&id=66bd2457"
import script from "./ConversationsSearchListVirtual.vue?vue&type=script&lang=js"
export * from "./ConversationsSearchListVirtual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports